// import { IStatisticState } from './types';

const initialState = {
  actionProcessing: false,
  statistic: {
    betCount: 0,
    totalBets: 0,
    totalWin: 0,
    totalNetwin: 0,
    netwinByDates: [],
    totalUserBalance: 0,
    totalAgentBalance: 0,
    usersCount: 0,
    directTotalNetwin: 0,
    referrals: 0,
    rankedAgents: [],
  },
};

export default initialState;
